import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    idToken: null,
    navigation: null,
    error: null
  },
  mutations: {
    authUser(state, userData) {
      state.idToken = userData.token;
      state.error = null;
    },
    authNav(state, userNav) {
      state.navigation = userNav.navigation;
    },
    errors(state, errorData) {
      state.error = errorData.error;
    }
  },
  actions: {
    login({commit}, authData) {
      axios({
        method: 'post',
        url: 'https://controlapi.totalprocessing.com/api/login',
        data: { form: authData },
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
        })
        .then(response => {
          commit('authUser', {
            token: response.data.token,
          })

          localStorage.setItem('user_id', response.data.user.id);
          localStorage.setItem('name', `${response.data.user.first_name} ${response.data.user.surname}` )
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('remember_token', response.data.user.remember_token);
          localStorage.setItem('page_access', response.data.user.page_access);
          localStorage.setItem('sub_page_access', response.data.user.sub_page_access);
          localStorage.setItem('merchant_access', response.data.user.merchant_access);
          localStorage.setItem('department', response.data.user.department);
          localStorage.setItem('user_role', response.data.user.user_role);

          this.dispatch('getNavigation');
          if(localStorage.page_access.split(",").indexOf('11') == -1) {
            router.push('/');
          }
          else {
            router.push('/dashboard-guest');
          }
          
          return response.data.token;
        })
        .catch(e => {
          commit('errors', {
            error: e.response.data.error
        })
      })
    },
    getNavigation({commit}) {
      let pageAccess = localStorage.page_access == 'null' ? null : localStorage.page_access;
      let subPageAccess = localStorage.sub_page_access == 'null' ? null : localStorage.sub_page_access;

      axios({
      method: 'post',
      data: { pageAccess: pageAccess, subPageAccess: subPageAccess },
      url: 'https://controlapi.totalprocessing.com/api/client-get-navigation',
      config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
      })
      .then(response => {
        // console.log(response.data);
        const data = response.data;
        const tree = [];

        data.reduce(function(a, b, i, r) {

            // Add the parent nodes
            if(a.page_id != b.page_id){
                tree.push({ page_id: a.page_id,
                              page_name: a.page_name,
                              page_path: a.path,
                              page_icon: a.page_icon
                            });
            }

            // Add the last parent node
            if(i+1 == data.length) {
                tree.push({ page_id: b.page_id,
                              page_name: b.page_name,
                              page_path: b.path,
                              page_icon: b.page_icon
                            });

                // Add the child nodes to the parent nodes
                data.reduce(function(a, b) {
                    if(a.sub_page_id) {
                        const find = tree.findIndex(f => f.page_id == a.parent_id);

                        // Add the first child node to parent
                        if(!("children" in tree[find])) {
                            tree[find].children = [];

                            tree[find].children.push({ page_id: a.sub_page_id,
                                                      page_name: a.sub_page_name,
                                                      page_path: a.sub_page_path,
                                                      page_icon: a.sub_page_icon
                            });
                        }
                        // Add the remaining child nodes to parent nodes
                        else {
                            tree[find].children.push({ page_id: a.sub_page_id,
                                                      page_name: a.sub_page_name,
                                                      page_path: a.sub_page_path,
                                                      page_icon: a.sub_page_icon
                            });
                        }
                    }
                    return b;
                });
            }
            return b;
        });

        commit('authNav', {
          navigation: tree
        });
      })
      .catch(e => {
          this.errors.push(e)
      })
    },
    async autoLogin({commit}) {
      const token = localStorage.getItem('token');

      if(!token) {
        return;
      }

      try {
        const res = await axios({
        method: 'post',
        data: { userId: localStorage.user_id },
        url: 'https://controlapi.totalprocessing.com/api/get-user-oauth',
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
        })
        .then(response => {
          if(response.data[0].revoked == 0) {
            commit('authUser', { token: token });
            return response;
          }
          else {
            localStorage.clear();
            return null;
          }
        })
        .catch(e => {
            this.errors.push(e);
            return e;
        })
        return res;
      }
      catch(e) {
        console.log(e);
        return e;
      }
    }
  },
  getters: {
    isAuth(state) {
      return state.idToken !== null;
    },
    isNav(state) {
      return state.navigation;
    }
  }
})